import { Component, OnInit, Input } from '@angular/core';
import { PatientComponent } from '../patient/patient.component';

@Component({
  selector: 'app-patient-address',
  templateUrl: './patient-address.component.html',
  styleUrls: ['./patient-address.component.scss']
})
export class PatientAddressComponent extends PatientComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
